import { Container, Nav } from "react-bootstrap";
import { Navigate, NavLink, Outlet } from "react-router-dom";
import BaseLayout from "../../baseLayout";
import {
  canAccessFinanceModule,
  getStoredUser,
} from "../../utils/financeAccess";
import "./styles.css";

const TABS = [
  { to: "/financeiro/dashboard", label: "Dashboard", end: false },
  { to: "/financeiro/contas", label: "Contas", end: true },
  { to: "/financeiro/honorarios", label: "Honorários", end: true },
  { to: "/financeiro/despesas", label: "Despesas", end: true },
  { to: "/financeiro/relatorios", label: "Relatórios", end: true },
];

function Financial() {
  const user = getStoredUser();

  if (!canAccessFinanceModule(user)) {
    return <Navigate to="/" replace />;
  }

  return (
    <BaseLayout title={"Financeiro"} page={"finance"}>
      <Container>
        <Nav variant="tabs" className="financial-tabs mb-4">
          {TABS.map((tab) => (
            <Nav.Item key={tab.to}>
              <Nav.Link as={NavLink} to={tab.to} end={tab.end}>
                {tab.label}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        <Outlet />
      </Container>
    </BaseLayout>
  );
}

export default Financial;
